export default [
    {
        path: '/idea',
        component: () => import('../components/pages/idea/Idea.vue') ,
        meta: {
            title: '联系信息'
        }
    }

]